import { registerEnum } from '@cbbt/lib-interface';
var LegalStatus;
(function (LegalStatus) {
    LegalStatus["CHARITABLE_INCORPORATED_ORGANISATION"] = "Charitable Incorporated Organisation";
    LegalStatus["COMPANY_CONVERTED_CLOSED"] = "Company Converted / Closed";
    LegalStatus["FURTHER_EDUCATION_AND_SIXTH_FORM_COLLEGE_CORPS"] = "Further Education and Sixth Form College Corps";
    LegalStatus["ICVC_SECURITIES"] = "ICVC (Securities)";
    LegalStatus["ICVC_UMBRELLA"] = "ICVC (Umbrella)";
    LegalStatus["INVESTMENT_COMPANY_WITH_VARIABLE_CAPITAL"] = "Investment Company with Variable Capital";
    LegalStatus["LIMITED_LIABILITY_PARTNERSHIP"] = "Limited Liability Partnership";
    LegalStatus["LIMITED_PARTNERSHIP"] = "Limited Partnership";
    LegalStatus["OLD_PUBLIC_LIMITED"] = "Old Public Limited";
    LegalStatus["OTHER"] = "Other";
    LegalStatus["OVERSEAS_ENTITY"] = "Overseas Entity";
    LegalStatus["PLC"] = "PLC";
    LegalStatus["PRIVATE_COMPANY_LIMITED_BY_GUARANTEE"] = "Private Company Limited By Guarantee Without Share Capital Claiming Exemption Under Section 30 Of The 1985 Act From Using The Word \"LIMITED\"";
    LegalStatus["PRIVATE_COMPANY_LIMITED_BY_SHARES"] = "Private Company Limited By Shares Claiming Exemption Under Section 30 Of The 1985 Act From Using The Word \"LIMITED\"";
    LegalStatus["PRIVATE_LIMITED"] = "Private Limited";
    LegalStatus["PRIVATE_LIMITED_COMPANY"] = "Private Limited Company";
    LegalStatus["PRIVATE_LIMITED_COMPANY_WITHOUT_SHARE_CAPITAL"] = "Private Limited Company Without Share Capital";
    LegalStatus["PRIVATE_UNLIMITED"] = "Private Unlimited";
    LegalStatus["PRIVATE_UNLIMITED_COMPANY_WITHOUT_SHARE_CAPITAL"] = "Private Unlimited Company Without Share Capital";
    LegalStatus["PROTECTED_CELL_COMPANY"] = "Protected Cell Company";
    LegalStatus["REGISTERED_SOCIETY"] = "Registered Society";
    LegalStatus["ROYAL_CHARTER_COMPANY"] = "Royal Charter Company";
    LegalStatus["SCOTTISH_CHARITABLE_INCORPORATED_ORGANISATION"] = "Scottish Charitable Incorporated Organisation";
    LegalStatus["SCOTTISH_PARTNERSHIP"] = "Scottish Partnership";
    LegalStatus["UNITED_KINGDOM_SOCIETAS"] = "United Kingdom Societas";
})(LegalStatus || (LegalStatus = {}));
registerEnum(LegalStatus, 'LegalStatus');
export { LegalStatus };
//# sourceMappingURL=LegalStatus.js.map